<template>
  <label>{{ label }}</label>
  <span :class="errorMessage ? 'invalid' : ''">
    <slot></slot>
  </span>
  <small v-if="errorMessage" class="p-invalid invalid-text">{{ errorMessage }}</small>
</template>

<script>
export default {
  name: 'AppFormItem',
  props: {
    label: String,
    error: Object,
  },
  computed: {
    errorMessage() {
      return this.error && this.error.message;
    },
  },
};
</script>

<style scoped>
.invalid >>> input {
  border-color: #f44336;
}
.invalid-text {
  color: #f44336;
}
</style>